import { render, staticRenderFns } from "./lnk-dms-iframe.vue?vue&type=template&id=1bf64cba&scoped=true&"
import script from "./lnk-dms-iframe.vue?vue&type=script&lang=js&"
export * from "./lnk-dms-iframe.vue?vue&type=script&lang=js&"
import style0 from "./lnk-dms-iframe.vue?vue&type=style&index=0&id=1bf64cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf64cba",
  null
  
)

export default component.exports